module.exports = __webpack_public_path__ + "img/schedule-mans.5365d522.png";